import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import axiosInstance from "../../api/axiosInstance";

export default function Changepassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();

  // Password validation checks
  const validations = {
    length: newPassword.length >= 8,
    lower: /[a-z]/.test(newPassword),
    upper: /[A-Z]/.test(newPassword),
    number: /[0-9]/.test(newPassword),
    special: /[^A-Za-z0-9]/.test(newPassword),
  };

  const validateForm = () => {
    const newErrors = {};

    if (!oldPassword.trim()) {
      newErrors.oldPassword = "Old password is required";
    }

    if (!newPassword.trim()) {
      newErrors.newPassword = "New password is required";
    } else if (!Object.values(validations).every(Boolean)) {
      newErrors.newPassword = "Please meet all password requirements";
    }

    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      // Get user ID from localStorage
      const userData = localStorage.getItem("userMedical");
      let userId = null;

      if (userData) {
        try {
          const parsedData = JSON.parse(userData);
          userId = parsedData.data?.id;
        } catch (error) {
          console.error("Error parsing user data:", error);
        }
      }

      if (!userId) {
        Swal.fire("Error", "User information not found. Please login again.", "error");
        return;
      }

      const requestData = {
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmNewPassword: confirmPassword
      };

      const response = await axiosInstance.post(`changePassword/${userId}`, requestData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) {
        Swal.fire("Success", "Password changed successfully!", "success");
        // Clear form
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setErrors({});
        navigate("/Admin/myprofile");
      } else {
        Swal.fire("Error", response.data.message || "Failed to change password", "error");
      }
    } catch (error) {
      console.error("Error changing password:", error);
      if (error.response?.data?.message) {
        Swal.fire("Error", error.response.data.message, "error");
      } else {
        Swal.fire("Error", "Failed to change password. Please try again.", "error");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span
                  style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                  onClick={() => navigate(-1)}
                  title="Back"
                >
                  &larr;
                </span>
                Change Password
              </h5>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6 border-end">
                    {/* Old Password */}
                    <div className="mb-4" style={{ marginTop: "20px" }}>
                      <label className="form-label fw-semibold">Old Password</label>
                      <div className="position-relative">
                        <input
                          type={showOld ? "text" : "password"}
                          className={`form-control pe-5 ${errors.oldPassword ? 'is-invalid' : ''}`}
                          placeholder="Enter Old Password"
                          value={oldPassword}
                          onChange={(e) => setOldPassword(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-light border position-absolute end-0 top-50 translate-middle-y me-1 p-2"
                          onClick={() => setShowOld(!showOld)}
                          aria-label="Toggle old password visibility"
                        >
                          <i className={`ti ${showOld ? "ti-eye-off" : "ti-eye"}`} />
                        </button>
                      </div>
                      {errors.oldPassword && (
                        <div className="invalid-feedback d-block">{errors.oldPassword}</div>
                      )}
                    </div>

                    {/* New Password */}
                    <div className="mb-4">
                      <label className="form-label fw-semibold">New Password</label>
                      <div className="position-relative">
                        <input
                          type={showNew ? "text" : "password"}
                          className={`form-control pe-5 ${errors.newPassword ? 'is-invalid' : ''}`}
                          placeholder="Enter New Password"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-light border position-absolute end-0 top-50 translate-middle-y me-1 p-2"
                          onClick={() => setShowNew(!showNew)}
                          aria-label="Toggle new password visibility"
                        >
                          <i className={`ti ${showNew ? "ti-eye-off" : "ti-eye"}`} />
                        </button>
                      </div>
                      {errors.newPassword && (
                        <div className="invalid-feedback d-block">{errors.newPassword}</div>
                      )}
                    </div>

                    {/* Confirm Password */}
                    <div className="mb-4">
                      <label className="form-label fw-semibold">Confirm Password</label>
                      <div className="position-relative">
                        <input
                          type={showConfirm ? "text" : "password"}
                          className={`form-control pe-5 ${errors.confirmPassword ? 'is-invalid' : ''}`}
                          placeholder="Enter Confirm Password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <button
                          type="button"
                          className="btn btn-light border position-absolute end-0 top-50 translate-middle-y me-1 p-2"
                          onClick={() => setShowConfirm(!showConfirm)}
                          aria-label="Toggle confirm password visibility"
                        >
                          <i className={`ti ${showConfirm ? "ti-eye-off" : "ti-eye"}`} />
                        </button>
                      </div>
                      {errors.confirmPassword && (
                        <div className="invalid-feedback d-block">{errors.confirmPassword}</div>
                      )}
                    </div>
                  </div>

                  {/* Password Requirements */}
                  <div className="col-md-6 ps-md-5 pt-4 pt-md-0" >
                    <h6 className="fw-bold mb-3" style={{ marginTop: "20px" }}>New Password must contain:</h6>
                    <ul className="list-unstyled small">
                      <li className={`mb-2 ${validations.length ? "text-success" : "text-muted"}`}>
                        — At least 8 characters
                      </li>
                      <li className={`mb-2 ${validations.lower ? "text-success" : "text-muted"}`}>
                        — At least 1 lower letter (a-z)
                      </li>
                      <li className={`mb-2 ${validations.upper ? "text-success" : "text-muted"}`}>
                        — At least 1 uppercase letter (A-Z)
                      </li>
                      <li className={`mb-2 ${validations.number ? "text-success" : "text-muted"}`}>
                        — At least 1 number (0-9)
                      </li>
                      <li className={`mb-2 ${validations.special ? "text-success" : "text-muted"}`}>
                        — At least 1 special character
                      </li>
                    </ul>
                  </div>
                </div>

                {/* Buttons */}
                <div className="d-flex justify-content-end mt-4">
                  <button
                    type="button"
                    className="btn btn-outline-secondary me-3"
                    onClick={() => navigate(-1)}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                    style={{ marginRight: "20px" }}
                  >
                    {loading ? "Updating..." : "Update Password"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
